import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="text-accent-500 shrink-0 mt-0.5">
                    <i className="ri-question-line"></i>
                  </span>
                  {item.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-7">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}